import { render, staticRenderFns } from "./text-or-search-select.vue?vue&type=template&id=fe3d7d8e&"
import script from "./text-or-search-select.vue?vue&type=script&lang=ts&"
export * from "./text-or-search-select.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports